import { useEffect } from "react";
import BusinessCard from "../components/BusinessCard";

const joery = {
  name: "Joery De Keyser",
  role: "Founder",
  phone: "+32 483 23 21 63",
  phoneWa: "32483232163",
  email: "joery@jynova.be",
  website: "www.jynova.be",
  photo: "/joery.webp",
  vcf: "/joery.vcf",
};

export default function Joery() {
  useEffect(() => {
    document.title = "Joery De Keyser — JYNOVA";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute(
      "content",
      "Digitale visitekaart van Joery De Keyser — Founder bij JYNOVA. Bel, mail of bewaar het contact direct."
    );
  }, []);
  return <BusinessCard person={joery} />;
}
